/**
 * Auth provider configuration.
 *
 * Reads REACT_APP_AUTH_PROVIDER to determine which auth mode is active:
 *   - 'clerk'  (default) -- Clerk SaaS auth
 *   - 'oidc'             -- Generic OIDC IdP (on-prem)
 *   - 'local'            -- Email / password (on-prem)
 */

export type AuthProviderType = 'clerk' | 'oidc' | 'local';

export const AUTH_PROVIDER: AuthProviderType =
  (process.env.REACT_APP_AUTH_PROVIDER as AuthProviderType) || 'clerk';

export const isClerkAuth = AUTH_PROVIDER === 'clerk';
export const isOidcAuth = AUTH_PROVIDER === 'oidc';
export const isLocalAuth = AUTH_PROVIDER === 'local';

/** OIDC-specific settings (only relevant when AUTH_PROVIDER=oidc) */
export const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY || '';
export const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID || '';
export const OIDC_REDIRECT_URI =
  process.env.REACT_APP_OIDC_REDIRECT_URI || `${window.location.origin}/oidc/callback`;

/** Optional API audience -- when set, requests a JWT access token scoped to your API.
 *  Required by providers like Auth0 to return JWTs instead of opaque tokens. */
export const OIDC_AUDIENCE = process.env.REACT_APP_OIDC_AUDIENCE || '';
